export var forEachSibling = function (handler, target) {
    var _a;
    var nodes = ((_a = target.parentNode) === null || _a === void 0 ? void 0 : _a.children) || [];
    for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el && el !== target) {
            handler(el);
        }
    }
};
